export default __webpack_public_path__ + "static/media/dark-main-demo.fde39db3.png";